module.exports = __webpack_public_path__ + "static/media/黑色底白色字-2.f2c719a5.png";